
import PrimaryButton from '@/components/ui/primaryButton.vue';
import Field from '@/components/ui/field.vue';

export default {
  name: 'Reset',

  components: {
    Field,
    PrimaryButton,
  },

  data() {
    return {
      email: null,
      error: null,
      done: false,
    };
  },

  computed: {
    buttonMessage() {
      return this.done
        ? this.$t('login.mailSent')
        : this.$t('login.resetPassword');
    },
  },

  watch: {
    email(value) {
      if (value && this.error) {
        this.error = null;
      }
    },
  },

  methods: {
    submit() {
      if (this.email) {
        this.$bolev
          .requestResetPassword({
            email: this.email,
            url: window.location.href,
            domain: window.location.origin,
          })
          .then(() => {
            this.done = true;
          })
          .catch(() => {
            this.error = this.$t('global.emailNotFound');
          });
      } else {
        this.error = this.$t('global.emailNotFound');
      }
    },
  },
};
